import { Typography } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../theme';

export const Subtitle = styled(Typography)`
  && {
    margin-bottom: ${({ theme }) => theme.spacing.s1};
    color: ${COLORS.black30};
  }
`;

export const TooltipData = styled.div`
  && .MuiListItem-root {
    margin-bottom: ${({ theme }) => theme.spacing.s1};
  }

  .MuiListItemText-root {
    margin: 0;
  }

  .MuiTypography-root {
    font-size: ${({ theme }) => theme.fontSize.body2};
    line-height: ${({ theme }) => theme.lineHeight.body2};
  }
`;
